// extracted by mini-css-extract-plugin
module.exports = {"default":"categories-module--default--127LF","categorySignal":"categories-module--category-signal--1m3yd"};